// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"76":"8d4f78e8","833":"26477951","904":"3f05dd74","996":"3f05dd74"}[chunkId] + ".chunk.css";
};